import React from 'react';
import { List } from '@chakra-ui/react';
var IconList = function IconList(_ref) {
  var color = _ref.color,
    children = _ref.children,
    _ref$textStyle = _ref.textStyle,
    textStyle = _ref$textStyle === undefined ? 'p2' : _ref$textStyle;
  return /*#__PURE__*/React.createElement(List, {
    className: "fa-ul",
    "data-testid": "core-icon-list",
    color: color,
    textStyle: textStyle
  }, children);
};
IconList.displayName = "IconList";
export { IconList };